'use client';

import {
  ProductGalleryPrevControl,
  ProductGalleryVariant,
} from '@vs-shop/commerce-ui/productGallery';
import { useIntl } from 'react-intl';

type Props = {
  onPrev: () => void;
  disabled?: boolean;
};

/** rcprofi's step back through the gallery's media. */
export default function GalleryPrevStandaloneButton({ onPrev, disabled = false }: Props) {
  const intl = useIntl();

  return (
    <ProductGalleryPrevControl
      variant={ProductGalleryVariant.INLINE}
      disabled={disabled}
      onClick={onPrev}
      aria-label={intl.formatMessage({
        id: 'component.server.page.product.gallery.galleryModalPrevButton.previous',
        defaultMessage: 'Předchozí',
      })}
    >
      <span className="sr-only">
        {intl.formatMessage({
          id: 'component.client.page.product.gallery.galleryPrevStandaloneButton.previous',
          defaultMessage: 'Předchozí obrázek',
        })}
      </span>
    </ProductGalleryPrevControl>
  );
}
